import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPuantajStats } from '@mocks/puantaj';
import { getSantiyeGunluguStats } from '@mocks/santiyeGunlugu';

import DashboardHeader from './DashboardHeader';
import DashboardStats from './DashboardStats';
import HizliDaireErisim from './HizliDaireErisim';
import HizliErisimKartlari from './HizliErisimKartlari';
import OperasyonOzeti from './OperasyonOzeti';

/**
 * İnşaat Modülü — Ana Sayfa / Hızlı Bakış
 * 
 * Yapı (yukarıdan aşağıya):
 * 1. Header — başlık + tarih
 * 2. Stats — yapım odaklı metrikler (Proje/İlerleme/Blok/Daire)
 * 3. Daire Bul & Güncelle — cascade selector (kullanıcı favorisi)
 * 4. Hızlı Erişim — kompakt navigasyon kartları
 * 5. Operasyon Özeti — puantaj + şantiye günlüğü (bugünün verileri)
 */
export default function InsaatDashboard() {
    const { constructions, selectedConstruction, showAllConstructions } = useSelector((state) => state.construction);

    const insaatData = useMemo(() => {
        if (showAllConstructions) return constructions;
        return constructions.filter(c => c.id === selectedConstruction?.id);
    }, [constructions, selectedConstruction, showAllConstructions]);

    const ortalamaIlerleme = insaatData.length > 0
        ? Math.round(insaatData.reduce((acc, c) => acc + (c.progress || 0), 0) / insaatData.length)
        : 0;

    const puantajStats = getPuantajStats(
        showAllConstructions ? null : selectedConstruction?.id,
        new Date().toISOString().split('T')[0]
    );
    const gunlukStats = getSantiyeGunluguStats(
        showAllConstructions ? null : selectedConstruction?.id
    );

    return (
        <div className="p-4 md:p-6 space-y-6">
            <DashboardHeader
                showAllConstructions={showAllConstructions}
                selectedConstruction={selectedConstruction}
            />

            <DashboardStats insaatlar={insaatData} />

            <HizliDaireErisim insaatlar={insaatData} />

            <HizliErisimKartlari
                puantajStats={puantajStats}
                gunlukStats={gunlukStats}
                ortalamaIlerleme={ortalamaIlerleme}
            />

            <OperasyonOzeti
                puantajStats={puantajStats}
                gunlukStats={gunlukStats}
            />
        </div>
    );
}
